import React, { Dispatch, useMemo } from 'react';
import classes from './PostSourceFilterGroup.module.scss';
import { PostScheduleFilterAction } from '../../../models/post';
import { PostScheduleViewContext } from '../../../modules/Publish/PostSchedule/PostSchedule.controller';
import { FilterItemGroup } from '../FilterItemGroup';
import { FilterItem } from '../FilterItem';
import { PostQueueCountResult, QueueFilterPostSource } from '../../../models/graphql';
import { PostScheduleHelpers } from '../../../modules/Publish/PostSchedule/postScheduleHelpers';

export type PostSourceFilterGroupViewProps = {
  loading: boolean;
  dispatchFilters: Dispatch<PostScheduleFilterAction>;
  activeFilterId?: string;
  context: PostScheduleViewContext;
  queueCounts: PostQueueCountResult;
};

export const PostSourceFilterGroupView = (props: PostSourceFilterGroupViewProps): JSX.Element => {
  const { queueCounts } = props; // useContext(QueueCountContext);
  const setSelectedFilter = (id: string) => {
    props.dispatchFilters({ type: 'source', payload: { data: id, fetchPosts: true } });
  };

  const counts = useMemo(() => PostScheduleHelpers.getQueueCounts(queueCounts, 'source'), [queueCounts]);

  return (
    <FilterItemGroup title={'Filter By Source'}>
      <FilterItem
        selected={props.activeFilterId === QueueFilterPostSource.POST_EDITOR}
        count={counts.postEditor}
        loading={props.loading}
        setSelectedHandler={() => setSelectedFilter(QueueFilterPostSource.POST_EDITOR)}>
        <div className={classes.Label}>Post Editor</div>
      </FilterItem>
      <FilterItem
        selected={props.activeFilterId === QueueFilterPostSource.CSV_UPLOAD}
        count={counts.csvUpload}
        loading={props.loading}
        setSelectedHandler={() => setSelectedFilter(QueueFilterPostSource.CSV_UPLOAD)}>
        <div className={classes.Label}>CSV Upload</div>
      </FilterItem>
      <FilterItem
        selected={props.activeFilterId === QueueFilterPostSource.SOCIAL_IMPORT}
        count={counts.socialImport}
        loading={props.loading}
        setSelectedHandler={() => setSelectedFilter(QueueFilterPostSource.SOCIAL_IMPORT)}>
        <div className={classes.Label}>RSS/Social Import</div>
      </FilterItem>
      <FilterItem
        selected={props.activeFilterId === QueueFilterPostSource.AUTO_RSS}
        count={counts.autoRss}
        loading={props.loading}
        setSelectedHandler={() => setSelectedFilter(QueueFilterPostSource.AUTO_RSS)}>
        <div className={classes.Label}>RSS Auto-Importer</div>
      </FilterItem>
    </FilterItemGroup>
  );
};
